import React, {Component} from 'react';
// import studiosLogo from './images/wnyc-studios.svg';
import apple from './images/buttons/apple-podcast.svg';
import google from './images/buttons/google-play.svg';
import spotify from './images/buttons/spotify.svg';
import './vendor/font-awesome.min.css';
import './App.css';
import FontAwesome from 'react-fontawesome';
import fetchJsonp from 'fetch-jsonp';

const TWEET = "In 28 states, you can be fired just for being queer. Tell @nancy your story about whether and how you’re out at work--and at what cost";

class App extends Component {
  constructor(props) {
    super(props);
    let typeformUrl = 'https://wnyc.typeform.com/to/u2hVIf';
    this.state = {
      value: '',
      message: '',
      typeformUrl
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    fetch('https://api.wnyc.org/api/v1/browser_id/', {credentials: 'include'})
      .then(r => r.json())
      .then(d => this.setState({typeformUrl: typeformUrl + `?browser_id=${d.browser_id}`}));
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let url = 'https://nypublicradio.us5.list-manage.com/subscribe/post-json?u=4109fdd323aaac7078eadaa8f&id=29bf87e44a&EMAIL=' + this.state.value;

    fetchJsonp(url, {jsonpCallback: 'c'}).then(response => response.json().then(data => {
      this.setState({message: data.msg});
      var noEmail  = '0 - Please enter a value';
      var singleAt = '0 - An email address must contain a single @';
      var domainInvalid = '0 - The domain portion of the email address is invalid (the portion after the @: ab)';
      if (data.msg === noEmail) {
        this.setState({ message: 'Whoops! You need to enter your email.' })
      } else if (data.msg === singleAt) {
        this.setState({ message: 'Whoops! Your email address should only contain one @' })
      } else if (data.msg === domainInvalid) {
        this.setState({ message: 'Whoops! The domain portion of the email address is invalid (the portion after the @: ab)' })
      }
    }
    ));
    event.preventDefault();
  }
  
  openPopup(service, event) {
    let services = {
      twitter: {
        url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(TWEET)}`,
        height: 443
      },
      facebook: {
        url: 'https://www.facebook.com/sharer/sharer.php?u=https://project.wnyc.org/nancy/out-at-work/',
        height: 620
      }
    };
    let features = `titlebar=no,close=no,width=600,height=${services[service].height}`;
    event.preventDefault();
    window.open(services[service].url, '_blank', features);
  }
  
  render() {
    return (
      <div className="page">
        <div className="background">
          <div className="box">
            <div className="box__top">              
              <div className="box__share">
                Share:
                <a href="#" target="_blank"
                   className="link nancy_oaw_facebook_share" rel="nofollow noopener" onClick={this.openPopup.bind(null, 'facebook')}>
                  <FontAwesome name='facebook'/>
                  Facebook
                </a>
                <a href="#" target="_blank"
                   className="link nancy_oaw_twitter_share" rel="nofollow noopener" onClick={this.openPopup.bind(null, 'twitter')}>
                  <FontAwesome name='twitter'/>
                  Twitter
                </a>
              </div>
            </div>
            <div className="box__header">
              <div className="box__title">
                <h2>Out at Work</h2>
                <h3>From <a href="http://www.wnyc.org/shows/nancy" target="_blank">Nancy</a> podcast</h3>
              </div>
            </div>

            <div className="box__description">
              <p>We spend most of our waking lives at work, but how much of ourselves can we share there? At a time when LGBTQ workplace protections are under renewed threat, Nancy is spending season 2 at the water cooler.</p><p>We’re talking to people on the front lines of the legislative fight. And we’re sharing stories from people across the country &#8212; difficult, funny, embarrassing, surprising stories &#8212; about how they’re out (or not) on the job, and at what cost.</p>
            </div>

            <div className="box__newsletter">
              <h3 className="text--white">
                Listen to our Out at Work episode.
              </h3>
              
              <a href="http://www.wnyc.org/story/nancy-podcast-out-at-work/" target="_blank"><div className="survey__btn nancy_oaw_listen">Listen
              </div></a>

              <div className="mailchimp-form">
                <div dangerouslySetInnerHTML={{ __html: this.state.message }}/></div>
              </div>
            </div>

            <div className="box__subscribe">
              Subscribe to Nancy Podcast

              <div className="box__buttons">
                <ul>
                 <li>
                  <a href="https://itunes.apple.com/us/podcast/id1222041050" target="_blank"
                     title="Listen to the podcast on Apple Podcast">
                    <img src={apple} alt="Listen to the podcast on Apple Podcast"
                     className="nancy_oaw_apple_podcasts" />
                  </a>
                 </li>
                 <li>
                    <a href="https://play.google.com/music/listen#/ps/I7ftrfcvky2edgatprby27pashu" target="_blank"
                       title="Listen to the podcast on Google Play">
                      <img src={google} alt="Listen to the podcast on Google Play"
                       className="nancy_oaw_google_play" />
                    </a>
                 </li>
                 <li>
                    <a href="https://open.spotify.com/show/5C8MgjbpyLseXJnWewYMAr" target="_blank"
                       title="Listen to the podcast on Spotify Play">
                      <img src={spotify} alt="Listen to the podcast on Spotify"
                       className="nancy_oaw_spotify" />
                    </a>
                 </li>
                </ul>
                
                <div className="box__callout">
                  Nancy is excited to be collaborating with <a href="https://www.fastcompany.com/40456937/heres-everywhere-in-the-u-s-you-can-still-get-fired-for-being-gay-or-trans" target="_blank" rel="noopener nofollow">Fast Company</a>, where select stories related to this project will appear later this fall.
                </div>
              </div> 
              <div className="fineprint text--gray">
                <ul>
                  <li>View our <a href="http://www.wnyc.org/privacy/" target="_blank">privacy policy</a> and our <a href="http://www.wnyc.org/terms/" target="_blank">terms</a>.</li><li>&copy; 2017 <a href="http://wnycstudios.wnyc.org/" target="_blank" className="nancy_oaw_studios_footer">WNYC Studios</a></li>
                </ul>
              </div>

            </div>
          </div>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js